import { render, staticRenderFns } from "./SelectWrapper.vue?vue&type=template&id=4826fee3&scoped=true&"
import script from "./SelectWrapper.vue?vue&type=script&lang=js&"
export * from "./SelectWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SelectWrapper.vue?vue&type=style&index=0&id=4826fee3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826fee3",
  null
  
)

export default component.exports